import { useState } from 'react'

import CopyIcon from '@/assets/icons/copy.svg?react'
import EyeCloseIcon from '@/assets/icons/eye-close.svg?react'
import EyeOpenIcon from '@/assets/icons/eye-open.svg?react'
import { message } from '@/components'
import { useUserStore } from '@/stores/user'

export default function SshPubKeyComponent() {
  const userStore = useUserStore()
  const [show, setShow] = useState(false)
  return (
    <div className="bg-[#F2F5F8] rounded-lg p-4 t-lg font-bold flex items-center justify-between w-full min-w-0">
      <span className="break-all">{show ? userStore.sshPubKey : '************************'}</span>
      <div className="flex items-center gap-x-2 ml-6">
        <button
          type="button"
          className="text-tertiary"
          onClick={() => setShow((v) => !v)}
          aria-label={show ? 'hide' : 'show'}
        >
          {show ? <EyeOpenIcon width={20} height={20} /> : <EyeCloseIcon width={20} height={20} />}
        </button>

        <div className="w-[1px] h-[16px] bg-neutral-200"></div>

        <button
          type="button"
          className="text-highlight"
          onClick={() => {
            navigator.clipboard.writeText(userStore.sshPubKey)
            message.success('Copied')
          }}
        >
          <CopyIcon width={20} height={20} />
        </button>
      </div>
    </div>
  )
}
